import dayjs from 'dayjs';
import type { ListFilter } from '@/shared/ui/list/types';
import { fetchStatCityOptions, fetchStatRegionOptions } from './api';
import { FRANCHISE_OPTIONS, MONTH_OPTIONS, STAT_COUNTRY_OPTIONS } from './constants';

const INPUT_FORMAT = 'YYYY-MM-DDTHH:mm';
const RUSSIA_ID = '1';

const startOfToday = () => dayjs().startOf('day').format(INPUT_FORMAT);
const endOfToday = () => dayjs().endOf('day').format(INPUT_FORMAT);

/** `today`: pre-fill the range with the current day. */
export const dateRangeFilters = (today = false): ListFilter[] => [
  {
    name: 'create_time_from',
    label: 'От даты',
    kind: 'datetime',
    defaultValue: today ? startOfToday : '',
  },
  {
    name: 'create_time_to',
    label: 'До даты',
    kind: 'datetime',
    defaultValue: today ? endOfToday : '',
  },
];

/** Selecting a month fills the date range with that month of the current year. */
export const monthFilter: ListFilter = {
  name: 'month',
  label: 'Фильтрация по месяцам',
  kind: 'select',
  options: MONTH_OPTIONS,
  clientOnly: true,
  patchOnChange: (month) => {
    const day = month ? dayjs().month(Number(month)) : null;
    return {
      create_time_from: day ? day.startOf('month').format(INPUT_FORMAT) : '',
      create_time_to: day ? day.endOf('month').format(INPUT_FORMAT) : '',
    };
  },
};

export const franchiseFilter: ListFilter = {
  name: 'is_franchise',
  label: 'Франчайзи',
  kind: 'select',
  placeholder: 'Все',
  options: FRANCHISE_OPTIONS,
};

/** `russia`: pre-select Russia. */
export const placeFilters = (russia = false): ListFilter[] => [
  {
    name: 'country_id',
    label: 'Фильтрация по стране',
    kind: 'select',
    options: STAT_COUNTRY_OPTIONS,
    defaultValue: russia ? RUSSIA_ID : '',
  },
  {
    name: 'region_id',
    label: 'Фильтрация по региону',
    kind: 'select',
    dependsOn: 'country_id',
    loadOptions: fetchStatRegionOptions,
  },
  {
    name: 'city_id',
    label: 'Фильтрация по городу',
    kind: 'select',
    dependsOn: 'region_id',
    loadOptions: fetchStatCityOptions,
  },
];
